import { activeGameId, installPathForGame } from "../../util/selectors";
import { modLoadOrderReducer } from "./reducers/loadOrder";
import { loadOrderSettingsReducer } from "./reducers/settings";
import LoadOrderPage from "./views/LoadOrderPage";
import { getSafe } from "../../util/storeHelper";
import { generate, Interface, parser } from "./collections/loadOrder";
import { addGameEntry, findGameEntry } from "./gameSupport";
export default function init(context) {
    context.registerReducer(["persistent", "loadOrder"], modLoadOrderReducer);
    context.registerReducer(["settings", "loadOrder"], loadOrderSettingsReducer);
    context.registerMainPage("sort-none", "Load order", LoadOrderPage, {
        priority: 120,
        id: "generic-loadorder",
        hotkey: "E",
        group: "per-game",
        visible: () => {
            const currentGameId = activeGameId(context.api.store.getState());
            const gameEntry = findGameEntry(currentGameId);
            return gameEntry !== undefined ? true : false;
        },
        props: () => {
            return {
                getGameEntry: (gameId) => findGameEntry(gameId),
            };
        },
    });
    context.registerLoadOrderPage = (gameEntry) => {
        addGameEntry(gameEntry);
    };
    context.optional.registerCollectionFeature("generic_load_order_collection_data", (gameId, includedMods) => {
        const state = context.api.getState();
        const stagingPath = installPathForGame(state, gameId);
        const mods = getSafe(state, ["persistent", "mods", gameId], {});
        return generate(context.api, state, gameId, stagingPath, includedMods, mods);
    }, (gameId, collection) => parser(context.api, gameId, collection), () => Promise.resolve(), (t) => t("Load Order"), (state, gameId) => {
        const gameEntry = findGameEntry(gameId);
        if (gameEntry === undefined) {
            return false;
        }
        return !(gameEntry.noCollectionGeneration ?? false);
    }, Interface);
    return true;
}
